import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/lib/motion";
import api from "@/lib/api";
import { IMAGES } from "@/lib/content";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="relative z-10">
      <PageHeader
        overline="Client Voices"
        titleLines={["Words of", <span key="2" className="text-gold italic">Transformation</span>]}
        subtitle="Trusted by families, founders and industrialists across Dubai and the UAE."
        image={IMAGES.skyline2}
      />
      <section className="py-10 md:py-20">
        <div className="mx-auto max-w-7xl px-6 md:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.08}>
              <div className="relative glass rounded-3xl p-8 h-full" data-testid={`testimonial-${i}`}>
                <Quote className="text-gold/30 absolute top-6 right-6" size={40} />
                <div className="flex gap-1 mb-5">{Array.from({ length: t.rating }).map((_, j) => <Star key={j} size={16} className="fill-gold text-gold" />)}</div>
                <p className="text-[#CBD5E1] leading-relaxed">{`"${t.review}"`}</p>
                <div className="flex items-center gap-3 mt-7 pt-6 border-t border-white/10">
                  <img src={t.photo} alt={t.name} className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20" />
                  <div><div className="font-medium text-white">{t.name}</div><div className="text-xs text-[#94A3B8]">{t.city}</div></div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
